export class PromotionsApiConverter {
  convertPoints = data => {
    return ({
      myPoints: data.user_points,
      cashiersList: data?.rating
        // ?.sort((a, b) => b.point_balance - a.point_balance)
        ?.map((v, i)  => ({
          id: v.user_id,
          points: v.point_balance,
          place: i + 1,
        }))
    })
  }
}
